import { createFileRoute } from '@tanstack/react-router';
import Info from '../../../info/src/Info';

export const Route = createFileRoute('/_secured/info')({
  component: Info,
});
